import React from "react";

import "../css/FullstackPage.css";

import FullstackVideoPlayer_1 from "./FullStackVideoPlayer_1";
import FullstackVideoCard_1 from "./FullstackVideoCard";
import FullstackVideoPlayer_2 from "./FullStackVideoPlayer_2";
import FullstackVideoCard_2 from "./FullstackVideoCard_2";

const FullstackPage = () => {
  return (
    <>
      <div className="fullstack-page body white-letter centered-text">
        I always like to coding, here I want to share with you some of my
        projects, together with this exaples, is this page you are navigating
        right now, it was made on ReactJS and hosted on AWS using S3, Route53
        and CloudFront as you can notice is a safe page, I hope you enjoy them.
        <div className="my-rows">
          <FullstackVideoPlayer_1 />
          <FullstackVideoCard_1 />
        </div>
        <div className="my-rows">
          <FullstackVideoPlayer_2 />
          <FullstackVideoCard_2 />
        </div>
      </div>
    </>
  );
};

export default FullstackPage;
